export default class CalendarBindings {
    constructor(calendar) {
        this.calendar = calendar;
        this.calendarDetailsTag = '.js-product-calendar';
        this.confirmCalendar();

        this.offerToRentId = '';
    }

    confirmCalendar() {
        var $set = $(document).find('._js-calendar-confirm');
        var _this = this;
        $(document)
            //remove overlay on ESC
            .on('keyup', (e) => {
                if (e.keyCode === 27) {
                    this.calendar.toggleCalendarOverlay(false);
                }
            })
            //set flag is calendar details on the product page is opened
            .on('click', () => {
                if (!$('.js-product-calendar').length) {
                    return;
                }

                setTimeout(() => {
                    //detect is calendar opened
                    this.isCalendarDetailsOpened = $(this.calendarDetailsTag).closest('details').prop('open');
                    //hide body overlay on calendar close
                    if (!this.isCalendarDetailsOpened) {
                        this.calendar.toggleCalendarOverlay(false);
                        $('._choose-for-rent').removeClass('_choose-for-rent');
                    }
                }, 10);
            })
        .on('click', '._js-calendar-confirm', function(e) {

            let $target = $(e.target),
                $iepollyfil = $target.closest('.open'),
                $calendar = $target.closest('.calendar'),
                startDate = $calendar.find('.calendar__field:first-of-type').val(),
                endDate = $calendar.find('.calendar__field:last-of-type').val(),
                $cartItem = $target.closest('.cart-item');

            $calendar.attr('data-start', startDate);
            $calendar.attr('data-end', endDate);

            var startDateVal = new Date(startDate);
            var endDateVal = new Date(endDate);
            var periodVal = Math.ceil(Math.abs(startDateVal.getTime() - endDateVal.getTime()) / (1000 * 3600 * 24));
            if (startDateVal == endDateVal) {
                endDateVal = new Date(startDateVal).setDate(new Date(startDateVal).getDate() + 1);
                periodVal = 1;
            }
            $cartItem.attr('data-offer-start', startDate);
            $cartItem.attr('data-offer-period', periodVal);


            var n = $set.index(this);
            _this.calendar.calendars[n].set_date([startDate, endDate]);

            if ($iepollyfil.length == 0) {
                $target.closest('._js-select-custom').removeAttr('open');
            } else {
                $iepollyfil.find('.calendar_opened').hide();
            }

            if(typeof filterShopaholicAjaxRequest == 'function' && window.isCalendarDateSelected) {
                filterShopaholicAjaxRequest();
            }

            //set flag is user selected rent dates
            window.isDateSelected = true;
            //remove calendar overlay for body
            _this.calendar.toggleCalendarOverlay(false);

            // trigger rent button for current product offer
            $('._choose-for-rent').trigger('click');

            if ( $('.page-cart').length ) {
                $target.closest('.cart-item').find('.js-period')[0].dataset.period = periodVal;
                $target.trigger('data-attribute-changed');
            }
            return false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/calendar/CalendarBindings.js